import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "date-range-picker";
var DatePickerRange = /** @class */ (function () {
    function DatePickerRange(range) {
        if (range) {
            this.from = range.from;
            this.to = range.to;
        }
    }
    DatePickerRange.prototype.copy = function () {
        return new DatePickerRange(this);
    };
    return DatePickerRange;
}());
export { DatePickerRange };
var attributes = {
    FROM: 'from',
    TO: 'to',
    END_VALUE: 'end-value',
    MIN: 'min',
    MAX: 'max',
    OPEN: 'open',
    DISABLED: 'disabled',
    POPUP_CLASSES: 'popup-classes',
    MASKED: 'masked',
    MASK_FORMAT: 'mask-format',
    SHOW_MASK_FORMAT: 'show-mask-format',
    USE_CHAR_MASK: 'use-char-mask',
    VALUE_MODE: 'value-mode',
    TOGGLE: 'tcw-date-range-picker-toggle',
    DIALOG_WIDTH_THRESHOLD: 'dialog-width-threshold',
    ALLOW_INVALID_DATE: 'allow-invalid-date',
    SHOW_TODAY: 'show-today',
    SHOW_CLEAR: 'show-clear',
    DISABLED_DAYS_OF_WEEK: 'disabled-days-of-week'
};
var classes = {
    POPUP: 'tyl-date-range-picker__popup'
};
var selectors = {
    INPUT: 'input',
    TOGGLE: "[" + attributes.TOGGLE + "]"
};
var events = {
    CHANGE: elementName + "-change",
    OPEN: elementName + "-open",
    CLOSE: elementName + "-close",
    INPUT: elementName + "-input"
};
export var DATE_RANGE_PICKER_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    events: events,
    attributes: attributes
};
